// Common states for the page templates (design spec §6.10). Hover changes a fill or a border
// only, over 120 ms; pressed is the --active fill (never a translate); disabled is 55 % opacity
// with a not-allowed cursor. Focus lives in focus-ring.ts.

/** Fill/border transitions at --dur-fast. */
export const HOVER_EASE = "transition-colors duration-(--dur-fast) ease-out";

/** A hairline card the user can click: the border darkens on hover. */
export const CARD_HOVER = `${HOVER_EASE} hover:border-strong`;

export const DISABLED =
  "disabled:cursor-not-allowed disabled:opacity-55 aria-disabled:cursor-not-allowed aria-disabled:opacity-55";

/** Hairline section card (design spec §6.8): radius 11, --border, --card. */
export const SECTION_CARD = "rounded-lg border border-border bg-card text-card-foreground";
